import {hbox, hspacer} from '@xh/hoist/cmp/layout';
import {XH} from '@xh/hoist/core';
import {hoistCmp} from '@xh/hoist/core';
import {Icon} from '@xh/hoist/icon';
import moment from 'moment';
import {HOURS, MINUTES, SECONDS} from '@xh/hoist/utils/datetime';
import './ExchangeStatus.scss';
import {ExchangeInfo} from '../../data/DataTypes';

export const exchangeStatus = hoistCmp.factory(() =>
    hbox({
        className: `exchange_status ${getExchangeStyle(XH.exchangeService.exchangeInfo)}`,
        alignItems: 'center',
        title: 'Exchange Info',
        items: [
            Icon.fund(),
            hspacer(5),
            XH.exchangeService.exchangeInfo.isOpen ? 'closes in ' : 'opens in ',
            fmtDuration(XH.exchangeService.exchangeInfo.nextEventSec * 1000)
        ]
    })
);

function getExchangeStyle(exchangeInfo: ExchangeInfo): string {
    if (!exchangeInfo.isOpen) return 'closed';
    if (exchangeInfo.nextEventSec < 300) return 'closing';
    return 'open';
}

function fmtDuration(durationMs: number): string {
    if (durationMs > 24 * HOURS) return moment.duration(durationMs).humanize();
    if (durationMs < 1000) return '<1s';

    const hours = Math.floor(durationMs / HOURS),
        minutes = Math.floor((durationMs % HOURS) / MINUTES),
        seconds = Math.floor((durationMs % MINUTES) / SECONDS);

    let ret = '';
    if (hours > 0) ret += hours + 'h';
    if (minutes > 0) ret += minutes + 'm';
    if (seconds > 0) ret += seconds + 's';
    return ret;
}
